import React from 'react'

function Footer() {
  return (
    <div className="bg-blue-900 text-center">
        <h1 className="font-bold text-3xl mb-4 pt-16 text-white">George Olufemi<span className="text-blue-500">.</span></h1>
        <p className="text-white pb-16">Copyright &copy; 2022 | All rights Reserved</p>
    </div>
  )
}

export default Footer;